import { getEndpoint } from '@/ui/core/config'
import { GuestbookClient } from '../GuestbookClient'
import { z } from 'zod'

export type UpdateInvitationInput = {
  eventId: string
  title: string
  message: string
  backgroundColor: string
  fontColor: string
}

export async function updateInvitation(
  this: GuestbookClient,
  input: UpdateInvitationInput,
): Promise<string> {
  const jwtToken = await this.auth.getJWT()
  if (!jwtToken) {
    throw new Error('No JWT token found')
  }

  const result = await fetch(getEndpoint('invitations'), {
    method: 'PUT',
    headers: {
      Authorization: jwtToken,
    },
    body: JSON.stringify(input),
  })

  if (!result.ok) {
    throw new Error(`Failed to update invitation: ${result.status}`)
  }

  // Handle 204 No Content response
  if (result.status === 204) {
    return input.eventId
  }

  // For other success responses, parse JSON
  return z.string().parse(await result.json())
}
